import { writable } from 'svelte/store';
import { browser } from '$app/environment';

const theme = writable(browser && JSON.parse(localStorage.getItem('theme') || 'false'));

theme.subscribe((value) => {
	if (browser) return localStorage.setItem('theme', value);
});

export default theme;
